import React, { forwardRef } from 'react';
import RefreshPairedWithText from '../text-pairing/Refresh';
const Refresh = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "M22.5 1.5v4.05l-2.025-2.025A11.963 11.963 0 0 0 12 0C5.363 0 0 5.362 0 12s5.363 12 12 12c4.988 0 9.3-3.075 11.1-7.425l-1.387-.563A10.476 10.476 0 0 1 12 22.5C6.188 22.5 1.5 17.812 1.5 12S6.188 1.5 12 1.5c2.888 0 5.513 1.163 7.425 3.075L21.6 6.75h-4.35v1.5H24V1.5z", fill: "currentColor" }))));
Refresh.displayName = 'Refresh';
// @ts-ignore;
const iconData = {
    glyph: Refresh,
    group: 'basic',
    textPairingGlyph: RefreshPairedWithText,
};
export default iconData;
